import { Table } from '@backstage/core-components';
import React from 'react';

const columns = [
  {
    title: "Name",
    width: "auto",
    field: "name",
    defaultSort: "asc"
  },
  {
    title: "Versions",
    width: "auto",
    field: "versions"
  }
];
const InfoDependenciesTable = ({
  infoDependencies
}) => {
  return /* @__PURE__ */ React.createElement(
    Table,
    {
      title: "Package Dependencies",
      options: {
        paging: true,
        pageSize: 15,
        pageSizeOptions: [15, 30, 100],
        loadingType: "linear",
        padding: "dense"
      },
      columns,
      data: infoDependencies || []
    }
  );
};

export { InfoDependenciesTable };
//# sourceMappingURL=InfoDependenciesTable.esm.js.map
